import { ArrowRightIcon } from '@phosphor-icons/react';
import ModalCloseButton from '../generic/ModalCloseButton';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

const NoDataModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleAttemptTest = () => {
    navigate(`/v2/home`);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-6"
      style={{
        background: 'rgba(16, 24, 40, 0.75)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <div className="relative bg-[var(--q3-surface-default)] rounded-xl p-8 sm:p-10 w-[90%] max-w-md">
        {/* <ModalCloseButton onClick={onClose} /> */}

        <div className="flex flex-col gap-5 items-center text-center">
          <p className="text-[var(--q3-neutral-default)] text-2xl sm:text-3xl font-bold">
            It looks like you didn't attempt any test yet!
          </p>
          <p className="text-[var(--q3-neutral-muted)] text-base sm:text-lg">
            You are about to visit the most relevant test series. Take a test to unlock detailed Quizrr Analysis and
            insights tailored for you.
          </p>
          <Button
            className="group flex items-center mt-4 shadow-none rounded-full w-full border-none !bg-[var(--q3-danger-normal)] hover:scale-100 transition-transform duration-300"
            onClick={handleAttemptTest}
          >
            Attempt a test to unlock Quizrr Analysis
            <ArrowRightIcon className="ml-2 group-hover:translate-x-1 transition-all duration-300" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoDataModal;
